import React, { useState, useEffect } from 'react';
import Question from './Question';
import Navigation from './Navigation';
import Results from './Results';

const QuestionSlider = () => {
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [error, setError] = useState(0);
    const [personData, setPersonData] = useState({});
    const [settings, setSettings] = useState({});
    const [questions, setQuestions] = useState([]);

    window.dataLayer = window.dataLayer || [];
    useEffect(() => {
        fetch(`/gnfactory/especiales/2021/calculadora-renta-global-dual/settings.json`, { headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' } }).then(response => {
            response.json().then(settings => {
                setSettings(settings);
                setQuestions([settings.questions.contribuyente]);
            });
        })
    }, []);

    const sentNavigationEvent = (buttonName = 'next') => {
        const screen = currentQuestion >= questions.length ? { id: 'resultado', 'description': 'resultado' } : questions[currentQuestion];

        window.dataLayer.push({
            'event': 'ev_interaction',
            'data': {
                'screen': {
                    'id': screen.id,
                    'name': screen.description,
                },
                'element': {
                    'name': buttonName,
                    'action': 'Click'
                }
            }
        });
    };


    const updateQuestion = (next = true) => {
        if (next) { // Forward
            if (validateResponse()) {
                setError(false);
                if (currentQuestion === 0 && personData.contribuyente !== undefined) { // First time
                    initQuestions();
                    sentNavigationEvent('next');
                    setCurrentQuestion(currentQuestion + 1);
                } else if (questions.length > currentQuestion) {
                    sentNavigationEvent('next');
                    setCurrentQuestion(currentQuestion + 1);
                }
            } else {
                setError(true);
            }
        } else if (!next && currentQuestion > 0) {
            setError(false);
            sentNavigationEvent('previous');
            setCurrentQuestion(currentQuestion - 1);
        }
    }

    const initQuestions = () => {
        setQuestions([settings.questions.contribuyente, ...settings.questions.specifics[personData.contribuyente], ...settings.questions.generics]);
    }

    const reset = () => {
        sentNavigationEvent('reset');
        setCurrentQuestion(0);
        setQuestions([settings.questions.contribuyente]);
        setPersonData({})
    }

    const validateResponse = () => {
        var current = questions[currentQuestion];
        const excepts = ['tiene_discapacidad', 'conyuge']

        if (personData[current.id] !== undefined) {
            if (!isNaN(parseInt(personData[current.id], 10))) {
                return parseInt(personData[current.id], 10) > 0;
            } else if (!excepts.includes(current.id) && personData[current.id] === "si") {
                return personData[`monto_${current.id}`] !== undefined && !isNaN(parseInt(personData[`monto_${current.id}`], 10)) && parseInt(personData[`monto_${current.id}`], 10) > 0;
            }

            return true;
        }

        return false;
    }

    return <section className="AllContain">
        <div className="questions">
            {currentQuestion < questions.length ?
                <Question question={questions[currentQuestion]} data={personData} onChange={setPersonData} /> :
                currentQuestion > 0 ? <Results settings={settings} person={personData} /> : null
            }
        </div>
        {(currentQuestion == 0 || currentQuestion >= questions.length) && settings.messages &&
            <div className="warningCRG"><p>{currentQuestion == 0 ? settings.messages.warningFirst : settings.messages.warningLast}</p></div>
        }
        <Navigation question={currentQuestion} totalQuestions={questions.length} showError={error} settings={settings} onChange={updateQuestion} reset={reset} />
    </section>;
}

export default QuestionSlider;